import { useRouter } from 'next/router'
import { Col, Row, Grid } from 'rsuite'
import { generalHelpers } from '@tweddle-se-team/common/helpers'
import DownloadButton from '@/components/shared/downloadButton'
import useTranslation from '@/hooks/useTranslation'
import styles from './publicationResultHeader.module.scss'
import { ActionButton } from '@/components/styles'
import { SubaruPublicationTypeIcon } from '../customIcon'
import { useSelector } from 'react-redux'
import { configSelectors } from '@/store/configs'
import { customerHelper } from '@tweddle-se-team/common/constants'
import DirectionalArrow from '@/components/themes/common/icons/directionalArrow'

const { renamePubType } = generalHelpers
const { CUSTOMER_IDS } = customerHelper

const showBrowseIconByCustomer = {
  [CUSTOMER_IDS.SUBARU]: () => false,
  [CUSTOMER_IDS.NORDICS]: () => true
}

const PublicationResultHeader = ({
  publicationTypes,
  publication,
  cached,
  publication: {
    publicationType,
    contents: { ditaId, highres, webview }
  },
  user
}) => {
  const t = useTranslation()
  const router = useRouter()
  const customerId = useSelector(configSelectors.selectCustomerId)
  const hasWebViewOrPDF = highres || webview
  const publicationLabel = t(publicationType, renamePubType(publicationTypes, publicationType, 'label'))
  const showBrowseIcon = (showBrowseIconByCustomer[customerId] || showBrowseIconByCustomer[CUSTOMER_IDS.SUBARU])()

  return (
    <Grid fluid>
      <Row>
        <Col xs={24}>
          <span className={styles.iconLabelRow}>
            <SubaruPublicationTypeIcon
              name={publicationTypes?.[publicationType]?.icon || 'vehicleOwnerManual'}
              size={20}
              className={styles.headerIcon}
              aria-hidden="true"
            />
            <span className={styles.labelText}>{publicationLabel}</span>
          </span>
        </Col>
        <Col xs={24}>
          <div className={styles.publicationButtons}>
            {hasWebViewOrPDF && !cached && (
              <DownloadButton
                publication={publication}
                user={user}
                withMarginLeft={false}
                aria-label={t('download_publication', `Download ${publicationLabel} PDF`)}
              />
            )}
            {ditaId && (
              <ActionButton
                $withIcon={showBrowseIcon}
                onClick={() => router.push({ pathname: '/content', query: { id: ditaId, publicationType } })}
                appearance="primary"
                aria-label={t('browse_publication', `Browse ${publicationLabel}`)}
              >
                {t('browse')} {showBrowseIcon && <DirectionalArrow size={16} className="fix-btn-icon" />}
              </ActionButton>
            )}
          </div>
        </Col>
      </Row>
    </Grid>
  )
}

export default PublicationResultHeader
